import { getCargoCarriersCore, updateCargoCarrier } from '../requests';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

async function getCargoCarriers({ commit }) {

	commit('set', (state) => { state.loading = true; });

	try {
		await fetchCargoCarriers();

	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchCargoCarriers() {
		let response = await getCargoCarriersCore();
		commit('setCargoCarriers', response);
	}
}

async function setCargoCarrier({ commit }, { cargoCarrier, data, prop }) {
	if (cargoCarrier[prop] === data) return;

	let cargoCarrierClone = deepCopy(cargoCarrier);
	commit('set', () => { cargoCarrier[prop] = data; });
	let patch = rdbClient.createPatch(cargoCarrierClone, cargoCarrier);
	try {
		await updateCargoCarrier(cargoCarrier.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: cargoCarrier.id });
		}
		commit('set', () => { cargoCarrier[prop] = cargoCarrierClone[prop]; });
		throw (err);
	}
}

export default {
	getCargoCarriers,
	setCargoCarrier
};